<template>
    <div class="auth-mask position-absolute vw-100 vh-100">
        <b-row no-gutters class="justify-content-center vw-100 vh-100">
            <b-col sm="6" class="px-5 align-self-center">
                <form
                    @submit.prevent="login"
                    >
                    <b-form-group>
                        <p>わたしたちが◯◯◯◯◯です</p>
                        <span>◯◯◯◯◯に入る文字は？</span>
                        <b-form-input
                            v-model="form.onetime_password"
                            ref="formOnetimePassword"
                            type="text"
                            placeholder=""
                            required
                            >
                        </b-form-input>
                        <input-error :errors="error.onetime_password" />
                    </b-form-group>
                    <b-button block class="btn-theme" @click="login">回答する</b-button>
                </form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'auth_token',
            'trans',
            'trans_p',
        ])
    },
    data() {
        return {
            form: {
                onetime_password: null,
            },
            response: {},
            error: {},
        }
    },
    mounted() {
        this.step2()
    },
    methods: {
        login () {
            this.$store
                .dispatch('auth/login', this.form)
                .then((response) => {
                    this.step2()
                })
                .catch((error) => {
                    this.error = error
                })
        },
        step2 () {
            this.form.onetime_password = null

            this.error = Object.assign({})

            this.$nextTick(() => {
                this.$refs.formOnetimePassword.focus()
            })
        },
    },
}
</script>

<style>
.auth-mask {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: #fff;
}
</style>
